import LockupAudioPreview from './lockupAudioPreview'

export default LockupAudioPreview
